var map = {
	"./01-1.png": 803,
	"./01-2.png": 365,
	"./02-1.png": 37,
	"./02-2.png": 787,
	"./03-1.png": 88,
	"./03-2.png": 230,
	"./04-1.png": 939,
	"./04-2.png": 771,
	"./05-1.png": 754,
	"./05-2.png": 662,
	"./06-1.png": 261,
	"./06-2.png": 258,
	"./07-1.png": 114,
	"./07-2.png": 927,
	"./08-1.png": 186,
	"./08-2.png": 52,
	"./09-1.png": 738,
	"./09-2.png": 597,
	"./10-1.png": 410,
	"./10-2.png": 831,
	"./11-1.png": 101,
	"./11-2.png": 918,
	"./12-1.png": 198,
	"./12-2.png": 231,
	"./bolas4.png": 189
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 900;